import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { WithAlert, withAlert } from "@components/alert/withAlert";
import { AlertPosition } from "@components/alert/Alert";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";
import { IBankStatementEntity } from "@odata/GeneratedEntityTypes";
import {
    ISmartBankAccountFilterCustomData
} from "@components/smart/smartBankAccountFilter/SmartBankAccountFilter.utils";
import {
    BankStatementsFormViewForExtend
} from "@pages/banks/bankStatements/BankStatementsFormView";
import {
    calculateAndStoreTransactionCount,
    getBankAccountBalanceForDate,
    recalculateBalance
} from "@pages/banks/bankStatements/BankStatements.utils";
import { ClosingBalancePath, OpeningBalancePath } from "@pages/banks/bankStatements/BankStatementsDef";
import { ISmartFastEntriesActionEvent } from "@components/smart/smartFastEntryList";
import { DocumentTypeCode } from "@odata/GeneratedEnums";

interface IProps extends IFormViewProps<IBankStatementEntity, ISmartBankAccountFilterCustomData>, WithAlert {
    accountId?: number;
}

class LoanStatementsFormView extends BankStatementsFormViewForExtend {
    documentType = DocumentTypeCode.LoanTransaction;

    getAccounts = () => {
        return this.props.storage.context.getLoanAccounts(true) || [];
    }
}

export default withPermissionContext(withAlert({
    autoHide: true,
    position: AlertPosition.CenteredBottom
})(LoanStatementsFormView));